import InnovationRanking from '../components/InnovationRanking'
import IndustryHotWords from '../components/IndustryHotWords'
import Vue from 'vue'

let vm={
    components:{InnovationRanking,IndustryHotWords}
}


Vue.component("report-ranking", vm)
export default vm


// WEBPACK FOOTER //
// ./src/research_report/js/report_ranking.js